'use client'

import {
    Text,
    TextTypes,
    Retain,
    RetainSizeModifier,
    LayoutRSC as Layout,
    LayoutContentPaneRSC as LayoutContentPane,
    LayoutContentPaneType,
} from '@lib-components'
import { ReactElement } from 'react'

interface Props {
    title: ReactElement
    children: ReactElement
}

const ErrorPage = ({ title, children }: Props) => (
    <Layout retainSize={RetainSizeModifier.MEDIUM}>
        <LayoutContentPane paneType={LayoutContentPaneType.CONTENT}>
            <Retain className="mt-8">
                <div className="flex items-center gap-2">
                    <Text type={TextTypes.HEADING_1} className="mt-5 mb-6 flex">
                        {title}
                    </Text>
                </div>
                {children}
            </Retain>
        </LayoutContentPane>
    </Layout>
)

export default ErrorPage
